// Photo payloads shared between server and SPA.
//
// One rule dominates this file: `filePath` is RELATIVE (`groups/7/a1b2.jpg`) and
// the public URL is assembled by prefixing the configured CDN URL. The server
// sends both, so the client never has to know the prefix — but the relative path
// stays in the payload because it is what the database holds, and any tooling
// that has to reconcile the two needs to see it.
//
// The CDN URL must end in `/uploads`. See docs/architecture.md; it 404'd every
// photo on the site once.
export const ALLOWED_PHOTO_MIMES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
];
/** The `accept` attribute for a file input, kept in step with the allowlist. */
export const PHOTO_ACCEPT = ALLOWED_PHOTO_MIMES.join(',');
/** File extension per sniffed MIME. Never taken from the client filename. */
export const PHOTO_EXTENSIONS = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
};
/** Maximum caption length, enforced server-side and hinted in the form. */
export const CAPTION_MAX = 255;
//# sourceMappingURL=photos.js.map